import usePageContext from '@rover/react-lib/src/context/usePageContext';
import { selectors as homePageSelectors } from '@rover/react-lib/src/pages/index/HomePage/HomePage.duck';
import { useApiFrontendHomepageRebookingProfilesList } from '@rover/rsdk/src/apiClient/latest/api-frontend-homepage-rebooking-profiles-list';
import type { HomepageRebookingProfile } from '@rover/rsdk/src/apiClient/latest/model/homepageRebookingProfile';

import useDucks from './useDucks';

const selector = (state) => ({
  rebookingProfiles: homePageSelectors.getRebookingProfiles(state),
});

const useRebookingShim = (): HomepageRebookingProfile[] | undefined => {
  const { isReactQueryRoute } = usePageContext();

  const { data: selectedData } = useDucks({ selector });
  const { data: reactQueryData } = useApiFrontendHomepageRebookingProfilesList({
    query: { enabled: isReactQueryRoute },
  });

  return isReactQueryRoute ? reactQueryData : selectedData.rebookingProfiles;
};

export default useRebookingShim;
